var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Injectable } from '@angular/core';
import { NativeIncludeService } from "./native.include.service";
import { ServiceLocator } from "./service.locator";
import { WindowRef } from "../../window.ref";
import { CompanyService } from "../../../business/comp/service/company.service";
import { Observable } from "rxjs";
import { SessionInfo } from "../session/session.info.model";
import { AppConfig } from "../../../admin/app.config";
var ChemAPIJs = /** @class */ (function () {
    function ChemAPIJs(cs, winRef, includeService) {
        this.cs = cs;
        this.winRef = winRef;
        this.includeService = includeService;
        this.info = new SessionInfo();
    }
    ChemAPIJs.prototype.includeAll = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            Promise.all([
                _this.includeService.loadIncludesByName('jquery')
            ]).then(function (value) {
                Promise.all([
                    _this.includeService.loadIncludesByName('jquery.ui'),
                    _this.includeService.loadIncludesByName('jquery.cookie'),
                    _this.includeService.loadIncludesByName('jstorage'),
                    _this.includeService.loadIncludesByName('jquery.json'),
                    _this.includeService.loadIncludesByName('fancybox.css'),
                    _this.includeService.loadIncludesByName('jquerycustom.css'),
                    _this.includeService.loadIncludesByName('api.info'),
                    _this.includeService.loadIncludesByName('native_utils.js')
                ]).then(function (value) {
                    Promise.all([
                        _this.includeService.loadIncludesByName('fancybox'),
                        _this.includeService.loadIncludesByName('jcrop'),
                        _this.includeService.loadIncludesByName('chem.api.v1'),
                        _this.includeService.loadIncludesByName('utils')
                    ]).then(function (value) {
                        Promise.all([
                            _this.includeService.loadIncludesByName('onload'),
                            _this.includeService.loadIncludesByName('mychemistry.js') //loaded from website
                        ]).then(function (value) {
                            resolve(value);
                        });
                    });
                });
            });
        });
    };
    ChemAPIJs.prototype.initialise = function () {
    };
    ChemAPIJs.prototype.nativeCheckHasPermission = function () {
        var _this = this;
        return Observable.create(function (observer) {
            var loggedIn = ((_this.info.user && _this.info.user.name) ? true : false);
            if (loggedIn) {
                _this.info.CHEM_API.getDashboard('perms', function (result) {
                    if (result != AppConfig.admin.apiResultCodes.RESPONSE_LOGIN_REQUIRED) {
                        var hasPermission = result;
                        _this.info.hasPermission = hasPermission;
                    }
                    observer.next(result);
                    observer.complete();
                });
            }
            else {
                _this.info.hasPermission = false;
                observer.next(false);
                observer.complete();
            }
        });
    };
    ChemAPIJs.prototype.nativeLogout = function () {
        if (AppConfig.appCode == AppConfig.appCodes.BUS || AppConfig.appCode == AppConfig.appCodes.REPORT) {
            this.info.CHEM_API.logoutChemistry();
        }
        else {
            var native = this.winRef.nativeWindow;
            native.logout(); // call mychemistry.js->logout on website
        }
    };
    ChemAPIJs.prototype.nativeCheckBrowser = function () {
        this.info.isBrowserSupported = this.info.native_utils.native_detect_browser();
    };
    ChemAPIJs.prototype.getNativeInfo = function () {
        var params = new window.URL(location.href).searchParams;
        var queryString = window.location.search;
        var urlParams = new URLSearchParams(queryString);
        var lang = urlParams.get('lang');
        // this.info.lang = (params.has('lang') && params.get('lang') ? params.get('lang') : AppConfig.admin.languages[0].code);
        this.info.lang = lang ? lang : AppConfig.admin.languages[0].code;
        // console.log(this.info.lang);
        var native = this.winRef.nativeWindow;
        this.info.CHEM_TRANS = native["CHEM_TRANS"] || {};
        this.info.TRANS = native["TRANS_" + this.info.lang] || {};
        this.info.SURL = native["SURL"];
        this.info.LURL = native["LURL"];
        this.info.SA = native["SA"];
        this.info.CHEM_API = native["CHEMAPI"];
        if (this.info.CHEM_API) {
            if (this.info.CHEM_API.user) {
                //logged in
                this.info.user = this.info.CHEM_API.user;
                this.info.userPrefs = this.info.CHEM_API.user.userpreferences;
            }
        }
        return this.info;
    };
    ChemAPIJs.prototype.loadAllScripts = function () {
        var _this = this;
        return Observable.create(function (observer) {
            _this.includeService = ServiceLocator.injector.get(NativeIncludeService);
            _this.includeAll().then(function (value) {
                observer.next();
            });
        });
    };
    ChemAPIJs.prototype.nativeAuthCheckAsync = function (isNpmServeEnv, backendCheck) {
        var _this = this;
        if (backendCheck === void 0) { backendCheck = false; }
        return Observable.create(function (observer) {
            _this.includeService = ServiceLocator.injector.get(NativeIncludeService);
            _this.includeAll().then(function (value) {
                _this.getNativeInfo();
                var native = _this.winRef.nativeWindow;
                _this.info.native_utils = native['native_utils'];
                _this.nativeCheckBrowser();
                if (isNpmServeEnv || AppConfig.appCode == AppConfig.appCodes.BUS || AppConfig.appCode == AppConfig.appCodes.REPORT) {
                    native['CLBACK'] = AppConfig.links.login_callback_url.app;
                }
                else {
                    native['CLBACK'] = AppConfig.links.login_callback_url.website;
                }
                if (_this.info.CHEM_API) {
                    if (!backendCheck && _this.info.CHEM_API.user) {
                        //already logged in
                        _this.info.user = _this.info.CHEM_API.user;
                        _this.nativeCheckHasPermission().subscribe(function (permissionResult) {
                            if (permissionResult == AppConfig.admin.apiResultCodes.RESPONSE_LOGIN_REQUIRED) {
                                _this.info.user = null;
                            }
                            observer.next(_this.info);
                            observer.complete();
                        });
                    }
                    else {
                        //check if there is already an active backend session
                        _this.info.CHEM_API.login(JSON.stringify({ fl: 'skpc' }), function (user) {
                            _this.info.user = user;
                            if (backendCheck) {
                                _this.info.CHEM_API.setUser(user);
                            }
                            _this.nativeCheckHasPermission().subscribe(function (permissionResult) {
                                if (permissionResult == AppConfig.admin.apiResultCodes.RESPONSE_LOGIN_REQUIRED) {
                                    _this.info.user = null;
                                }
                                observer.next(_this.info);
                                observer.complete();
                            });
                        }, function () {
                            //completedCallback, see RestController.RESPONSE_EMAIL_VERIFICATION
                            if (!_this.info.user) {
                                observer.next(_this.info);
                                observer.complete();
                            }
                        });
                    }
                }
                else {
                    console.log("info.CHEM_API undefined");
                }
            });
        });
    };
    ChemAPIJs = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [CompanyService, WindowRef, NativeIncludeService])
    ], ChemAPIJs);
    return ChemAPIJs;
}());
export { ChemAPIJs };
//# sourceMappingURL=chem.api.js.js.map